enum AgencyBrandThemeMode {
	Light = 0,
	Dark = 1 
}

export default AgencyBrandThemeMode;